module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagea"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg",
      "width": "100%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO LITTLE GIRLS ARE PLAYING IN THEIR MOTHER’S CLOSET")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE OLDER ONE HOLDS UP A SENSIBLE BLACK PUMP:")]), _vm._v(" “A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND MAY")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SUGGEST FOR")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADAME SOMETHING IN A SNOWSHOE")]), _vm._v("?” T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE YOUNGER ONE GIGGLES BACK,")]), _vm._v(" “N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O THANK YOU,")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSIEUR, YOU KNOW")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("POSITIVELY LOATHE A PURPLE SNOWSHOE.")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("And so it goes on, for hours and days. Mom’s hiking boots are reimagined as dancing shoes. Her loafers become scuba flippers. Playing shoe store takes the imagination on vacation in a way that nothing else can.")])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0007-02"
    }
  }, [_c('div', {
    staticClass: "imgblock W90"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-02.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0007-02"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To create the designs for this collection, I took a trip back to that imaginary shoe store in my mom’s closet. You won’t believe what I found in there.… Slippers for lounging, dancing, and doing battle. Slippers for silliness, self-reflection, and dashing through the snow. Animal, vegetable, and mineral: they’re all here. Feel like a fox, or a fish? Professor or princess? Here are the slippers for you. Knitted or felted, buttoned or belted—there’s a slipper here for every foot.")])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0007-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0007-03"
    }
  }, [_c('div', {
    staticClass: "imgblock W80"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-03.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0007-03"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slippers require less in the way of yarn, time, or commitment than other knitting projects. That makes them ideal gifts: fun to make, fun to receive. Especially if the recipient is you! Handmade slippers fit and feel better than anything you can buy. And then there’s the customization: Need more durability? Add some soles. Need less coverage in the summer and more warmth in the winter? Make a seasonal slipper wardrobe. The only limits are the ones on your imagination.")])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0007-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0007-04"
    }
  }, [_c('div', {
    staticClass: "imgblock W70"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-04.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0007-04"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("You hold in your hand a key to the magical closet. Within you will find fantastical footwear for you and your loved ones. From boots to scuffs, and skimmers to loafers, there’s a shape and size for you and everybody you knit for.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc9052c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 72
// module chunks = 0